// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import Cookie from 'js.cookie';
import { injectionParams, ZonstAuth } from '@zonst/apm'
// import { ZonstAuth } from '@zonst/http'
import storage from 'good-storage';
import App from './App';
import router from './router';
import store from './store';

// vue实例注入原型链
import vuePrototype from './api/mainApiPrototype'
import ElementUI,{ Table } from 'element-ui'
import * as Sentry from "@sentry/vue";
initSentry();
// 初始化新版本sentry
function initSentry() {
  if (process.env.VUE_APP_MODE === "dev") {
    return
  }
  let user = {};
  let userStr = localStorage.getItem("user_info_new");
  if(userStr) {
    try {
      user = JSON.parse(userStr);
    } catch (error) {
      throw Error(error)
    }
  }
  Sentry.init({
    Vue,
    dsn: "https://cf49c6e51c974e6ca09180649b62be66@sentry.xq5.com/27",
    release: 'v1.0.0',
    integrations: [
      new Sentry.BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
        tracingOrigins: ["localhost", "http://test.wxopapp.xq5.com/", "https://wxopapp.xq5.com/", "https://wxopapp.xq668.com/","https://wxopapp.xq556.com/"],
      }),
    ],
    environment: process.env.VUE_APP_MODE,
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0
  });
  Sentry.setUser({
    username: `${user.user_name},${user.zonst_user_id}`
  })
}
// 解决 「ResizeObserver loop limit exceeded」问题
const fixElTableErr = table => {
  const oldResizeListener = table.methods.resizeListener
  table.methods.resizeListener = function () {
    window.requestAnimationFrame(oldResizeListener.bind(this))
  }
}
// 在Vue.use之前执行此函数
fixElTableErr(Table)
Vue.use(ElementUI)

vuePrototype()

// 接入统一日志上报
injectionParams(() => ({
  env: process.env.VUE_APP_MODE === 'dev' && process.env.NODE_ENV === 'production' ? 'test' : 'prod',
  journalType: 1,
  platformKey: 'wxopappsvr',
  token: storage.get('token'),
}));

Vue.prototype.$Auth = new ZonstAuth(process.env.VUE_APP_MODE.includes('master') ? 'prod' : 'dev');




// -.-..-..-..--.-
// /----.-.---.----/-.-----..-...../
// -.--.---....---/-..-.-.-....-.--/-------...-.--./
// -.-...--..--..-/--------....--../-.-.-......---./
// -.-..------..../-..-....---.-.../-.-..-......--./
// -.-----..-...../-.--.---....---/-..-.-.-....-.--/
// -------...-.--./-.-...--..--..-/--------....--../-.-------....--/
// -...-....-....../-.-..---....--./----.-.....-.--/--------....--../
// -...--....-.-.../--....-.-..---./-..----...--.../-.-..--...-.--./
// --..........-./-...--....-...-./-...--....-...-.

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App },
  data: {
    real_name: '',
    token: '',
  },
  created() {
    document.title = '小游戏配置平台'
    store.dispatch({ type: 'getChannelPackage' })
  },
  methods: {
    checkValueisNotEmpty(value) {
      const valueType = Object.prototype.toString.call(value)
      if (valueType === '[object Object]') {
        if (Object.keys(value).length === 0) {
          return true
        }
      } else if (valueType === '[object Array]') {
        if (value.length === 0) {
          return true
        } else {
          for (let i = 0; i < value.length; i += 1) {
            this.checkValueisNotEmpty(value[i])
          }
        }
      } else if (valueType === '[object String]') {
        if (isNaN(Number(value))) {
          if (value.length === 0) {
            return true
          }
        } else {
          // eslint-disable-next-line no-lonely-if
          if (Number(value) === 0) {
            return true
          }
        }
      } else if (valueType === '[object Number]') {
        if (value === 0) {
          return true
        }
      } else if (valueType === '[object Null]') {
        return true
      }
      return false
    },
    // 数组取某个属性
    arrJSON(arr, value) {
      let a;
      arr.forEach((item) => {
        if (item.value === value) {
          a = item.label
        }
      });
      return a
    },

    // 数组去重
    dedupe(array) {
      return Array.from(new Set(array));
    },
    // 设置表格样式
    tableRowClassName({ rowIndex }) {
      if (rowIndex % 2 === 1) {
        return 'success-row';
      }
      return '';
    },

    // 时间处理
    date2str(x, y) {
      // eslint-disable-next-line
      const z = { M: x.getMonth() + 1, d: x.getDate(), h: x.getHours(), m: x.getMinutes(), s: x.getSeconds() };
      // eslint-disable-next-line
      y = y.replace(/(M+|d+|h+|m+|s+)/g, v => ((v.length > 1 ? '0' : '') + eval(`z.${v.slice(-1)}`)).slice(-2));
      return y.replace(/(y+)/g, v => x.getFullYear().toString().slice(-v.length));
    },


    // 搜索框数据记录
    cookiesUserIdArr(userId) {
      if (!userId || userId === '') {
        console.log(userId)
        return;
      }
      console.log(1111, typeof Cookie.get('userArr'), Cookie.get('userArr'));
      if (Cookie.get('userArr') === null || Cookie.get('userArr') === 'null' || Cookie.get('userArr') === 'object') {
        const arr = [userId];
        Cookie.set('userArr', JSON.stringify(arr))
      } else {
        const arr = JSON.parse(Cookie.get('userArr'));
        console.log(arr);
        arr.push(userId);
        const arrNew = new Set(arr);
        Cookie.set('userArr', JSON.stringify(arrNew));
      }
    },
    getFormtTime(dateTime, flag) {
      if (dateTime != null) {
        const date = new Date(dateTime);
        const YY = date.getFullYear();
        const MM = (date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1);
        const DD = (date.getDate() < 10 ? `0${date.getDate()}` : date.getDate());
        if (flag) {
          const hh = (date.getHours() < 10 ? `0${date.getHours()}` : date.getHours());
          const mm = (date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes());
          const ss = (date.getSeconds() < 10 ? `0${date.getSeconds()}` : date.getSeconds());
          return `${YY}-${MM}-${DD} ${hh}:${mm}:${ss}`;
        }
        return `${YY}-${MM}-${DD}`;
      }
      return '';
    },
    toDate(hasSeperator, date) {
      const nowDate = date;
      const y = nowDate.getFullYear();
      let m = nowDate.getMonth() + 1;
      m = m < 10 ? `0${m}` : m;
      let d = nowDate.getDate();
      d = d < 10 ? `0${d}` : d;
      if (hasSeperator) {
        return `${y}-${m}-${d}`;
      }
      return `${y}${m}${d}`
    },
    toTime(hasSeperator, date) {
      const nowDate = date;
      let h = nowDate.getHours();
      h = h < 10 ? `0${h}` : h;
      let min = nowDate.getMinutes();
      min = min < 10 ? `0${min}` : min;
      let s = nowDate.getSeconds();
      s = s < 10 ? `0${s}` : s;
      if (hasSeperator) {
        return `${h}:${min}:${s}`;
      }
      return `${h}${min}${s}`;
    },
    toDateTime(hasSeperator, date) {
      const nowDate = date;
      const y = nowDate.getFullYear();
      let m = nowDate.getMonth() + 1;
      m = m < 10 ? `0${m}` : m;
      let d = nowDate.getDate();
      d = d < 10 ? `0${d}` : d;
      let h = nowDate.getHours();
      h = h < 10 ? `0${h}` : h;
      let min = nowDate.getMinutes();
      min = min < 10 ? `0${min}` : min;
      let s = nowDate.getSeconds();
      s = s < 10 ? `0${s}` : s;
      if (hasSeperator) {
        return `${y}-${m}-${d} ${h}:${min}:${s}`;
      }
      return `${y}${m}${d}${h}${min}${s}`;
    },
    judgeType(obj) {
  // tostring会返回对应不同的标签的构造函数
      const toString = Object.prototype.toString;
      const map = {
        '[object Boolean]': 'boolean',
        '[object Number]': 'number',
        '[object String]': 'string',
        '[object Function]': 'function',
        '[object Array]': 'array',
        '[object Date]': 'date',
        '[object RegExp]': 'regExp',
        '[object Undefined]': 'undefined',
        '[object Null]': 'null',
        '[object Object]': 'object',
      };
      if (obj instanceof Element) {
        return 'element';
      }
      return map[toString.call(obj)];
    },
    deepClone(data) {
      const type = this.judgeType(data);
      let obj;
      if (type === 'array') {
        obj = [];
      } else if (type === 'object') {
        obj = {};
      } else {
    // 不再具有下一层次
        return data;
      }
      if (type === 'array') {
        // eslint-disable-next-line
        for (let i = 0, len = data.length; i < len; i++) {
          obj.push(this.deepClone(data[i]));
        }
      } else if (type === 'object') {
        // 对原型上的方法也拷贝了....
        // eslint-disable-next-line
        for (const key in data) {
          obj[key] = this.deepClone(data[key]);
        }
      }
      return obj;
    },
    floatObj() {
      function isInteger(obj) {
        return Math.floor(obj) === obj
      }
      function toInteger(floatNum) {
        const ret = { times: 1, num: 0 }
        if (isInteger(floatNum)) {
          ret.num = floatNum
          return ret
        }
        const strfi = `${floatNum}`
        const dotPos = strfi.indexOf('.')
        const len = strfi.substr(dotPos + 1).length
        // eslint-disable-next-line
        const times = Math.pow(10, len)
        const intNum = Number(floatNum.toString().replace('.', ''))
        ret.times = times
        ret.num = intNum
        return ret
      }
      function operation(a, b, digits, op) {
        const o1 = toInteger(a)
        const o2 = toInteger(b)
        const n1 = o1.num
        const n2 = o2.num
        const t1 = o1.times
        const t2 = o2.times
        const max = t1 > t2 ? t1 : t2
        let result = null
        switch (op) {
          case 'jia':
            if (t1 === t2) { // 两个小数位数相同
              result = n1 + n2
            } else if (t1 > t2) { // o1 小数位 大于 o2
              result = n1 + (n2 * (t1 / t2))
            } else { // o1 小数位 小于 o2
              result = (n1 * (t2 / t1)) + n2
            }
            return result / max
          case 'jian':
            if (t1 === t2) {
              result = n1 - n2
            } else if (t1 > t2) {
              result = n1 - (n2 * (t1 / t2))
            } else {
              result = (n1 * (t2 / t1)) - n2
            }
            return result / max
          case 'cheng':
            result = (n1 * n2) / (t1 * t2)
            return result
          case 'chu':
            result = (n1 / n2) * (t2 / t1)
            return result
          default:
            return 'floatObj函数运行错误'
        }
      }
      function jia(a, b, digits) {
        return operation(a, b, digits, 'jia')
      }

      function jian(a, b, digits) {
        return operation(a, b, digits, 'jian')
      }

      function cheng(a, b, digits) {
        return operation(a, b, digits, 'cheng')
      }

      function chu(a, b, digits) {
        return operation(a, b, digits, 'chu')
      }

  // exports
      return {
        jia,
        jian,
        cheng,
        chu,
      }
    },
    getSearchParam(name) {
      const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`, 'i');
      const r = window.location.search.substr(1).match(reg);
      if (r != null) {
        return decodeURIComponent(r[2]);
      }
      return '';
    },
    // 获取本周第一天
    getThisWeekFristDay() {
      const nowDay = new Date();
      const dayOfWeek = nowDay.getDay() ? nowDay.getDay() - 1 : 6;
      const thisWeekFristDay = new Date(nowDay.getTime() - (dayOfWeek * 24 * 60 * 60 * 1000));
      const thisyear = thisWeekFristDay.getFullYear();
      let thismonth = thisWeekFristDay.getMonth();
      let thisdate = thisWeekFristDay.getDate();
      if (thismonth < 9) {
        thismonth = `0${thismonth + 1}`;
      } else {
        thismonth += 1;
      }
      if (thisdate < 9) {
        thisdate = `0${thisdate}`;
      } else {
        thisdate += 1;
      }
      return new Date(`${thisyear}-${thismonth}-${thisdate}`);
    },
    // 获取本周最后一天
    getThisWeekLastDay() {
      const nowDay = new Date();
      const dayOfWeek = nowDay.getDay() ? nowDay.getDay() : 7;
      const thisWeekLastDay = new Date(nowDay.getTime() + ((7 - dayOfWeek) * 24 * 60 * 60 * 1000));
      const thisyear = thisWeekLastDay.getFullYear();
      let thismonth = thisWeekLastDay.getMonth();
      let thisdate = thisWeekLastDay.getDate();
      if (thismonth < 9) {
        thismonth = `0${thismonth + 1}`;
      } else {
        thismonth += 1;
      }
      if (thisdate < 9) {
        thisdate = `0${thisdate}`;
      } else {
        thisdate += 1;
      }
      return new Date(`${thisyear}-${thismonth}-${thisdate}`);
    },
    // 获取上周周第一天
    getLastWeekFirstDay() {
      const thisWeekFristDay = this.getThisWeekFristDay();
      return thisWeekFristDay - (7 * 24 * 60 * 60 * 1000);
    },
    // 获取上周最后一天
    getLastWeekLastDay() {
      const lastWeekFristDay = this.getLastWeekFirstDay();
      return lastWeekFristDay + (6 * 24 * 60 * 60 * 1000);
    },
    // 使用中 获取当前月第一天
    getTimeLastDay(data) {
      let myDate = data;
      if (myDate.toString()
        .match('-')) {
        myDate = new Date(myDate);
      }
      const thisyear = myDate.getFullYear();
      let thismonth = myDate.getMonth();
      if (thismonth < 9) {
        thismonth = `0${thismonth + 1}`;
      } else {
        thismonth += 1;
      }
      return `${thisyear}-${thismonth}-01`;
    },
    // 获取当前月第一天
    toDataFirstDate() {
      const myDate = new Date();
      const thisyear = myDate.getFullYear();
      let thismonth = myDate.getMonth();
      if (thismonth < 9) {
        thismonth = `0${thismonth + 1}`;
      } else {
        thismonth = `${thismonth + 1}`;
      }
      return `${thisyear}-${thismonth}-01`;
    },
    // 获取当前月最后一天
    getLastDayThisMonth() {
      const today = new Date();
      const thisYear = today.getFullYear();
      let thisMonth = today.getMonth();
      if (thisMonth < 9) {
        thisMonth = `0${thisMonth + 1}`;
      } else {
        thisMonth = `${thisMonth + 1}`;
      }
      const myDate = new Date(thisYear, thisMonth, 0)
      const lastDay = `${thisYear}-${thisMonth}-${myDate.getDate()}`
      return lastDay;
    },
    // 获取上月月第一天
    toDataLastDate() {
      const myDate = new Date();
      let thisyear = myDate.getFullYear();
      let thismonth = myDate.getMonth();
      if (thismonth === 0) {
        thismonth = 12;
        thisyear -= 1;
      }
      if (thismonth <= 9) {
        thismonth = `0${thismonth}`;
      }
      return `${thisyear}-${thismonth}-01`;
    },
    // 获取上月最后一天
    toGetLastDate() {
      const nowdays = new Date();
      let year = nowdays.getFullYear();
      let month = nowdays.getMonth();
      if (month === 0) {
        month = 12;
        year -= 1;
      }
      if (month < 10) {
        month = `0${month}`;
      }
      const myDate = new Date(year, month, 0);
      const lastDay = `${year}-${month}-${myDate.getDate()}`;
      return lastDay;
    },
    // 获取今年第一天
    getThisYearFristDay() {
      const thisYear = new Date().getFullYear();
      return `${thisYear}-01-01`;
    },
    // 获取今年最后一天
    getThisYearLastDay() {
      const thisYear = new Date().getFullYear();
      const lastDay = new Date(thisYear, 12, 0);
      return `${thisYear}-12-${lastDay.getDate()}`;
    },
    // 获取去年第一天
    getLastYearFristDay() {
      const lastYear = new Date().getFullYear() - 1;
      return `${lastYear}-01-01`;
    },
    // 获取去年最后一天
    getLastYearLastDay() {
      const lastYear = new Date().getFullYear() - 1;
      return `${lastYear}-12-31`;
    },
  },
});
